import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import './Nav.css';

const Nav = () => {
    const { theme, toggleTheme } = useTheme();
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if(offset > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleContactClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        
        // Close mobile menu if open
        setMenuOpen(false);
        
        // Smooth scroll to contact section
        const contactElement = document.getElementById('contact');
        if (contactElement) {
            contactElement.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <div className='navbar-container'>
                <Link to="/" className='navbar-logo'>
                    <span className='logo-text'>LH</span>
                </Link>

                <div className='menu-icon' onClick={toggleMenu}>
                    <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'} />
                </div>
            </div>
            <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
                <li className='nav-item'>
                    <Link 
                        to='/'
                        className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}
                        onClick={() => setMenuOpen(false)}
                    >
                        Home
                    </Link>
                </li>
                { <li className="nav-item">
                        <Link 
                            to="/dj-events" 
                            className={location.pathname === '/dj-events' ? 'nav-link active' : 'nav-link'}
                            onClick={() => setMenuOpen(false)}
                        >
                            DJ
                        </Link>
                    </li> }
                    <li className="nav-item">
                        <Link 
                            to="/blog" 
                            className={location.pathname === '/blog' ? 'nav-link active' : 'nav-link'}
                            onClick={() => setMenuOpen(false)}
                        >
                            Blog
                        </Link>
                    </li>
                    <li className="nav-item">
                        <a 
                            href="#contact" 
                            className="nav-link"
                            onClick={handleContactClick}
                        >
                            Contact
                        </a>
                    </li>
            </ul>
            <button className='theme-toggle' onClick={toggleTheme} aria-label='Toggle theme'>
                <i className={theme === 'light' ? 'fas fa-moon' : 'fas fa-sun'} />
            </button>
        </nav>
    );
};

export default Nav;